export const SMART_COLORS = {
  page: '#fbfaf7',
  card: '#fffdf8',
  cardSoft: '#f7f3ea',
  line: '#eadfca',
  text: '#4f545c',
  muted: '#7a7f87',
  gold: '#b79b5b',
  goldHover: '#a68847',
  goldSoft: '#efe4cb',
  blue: '#6f8fa6',
  blueSoft: '#eaf2f6',
  green: '#789b82',
  greenSoft: '#edf5ee',
  rose: '#b97878',
  roseSoft: '#f6ecea',
  warning: '#c29355',
  warningSoft: '#f7ead8',
};

export const smartCardSx = {
  border: `1px solid ${SMART_COLORS.line}`,
  borderRadius: 2,
  background: SMART_COLORS.card,
  boxShadow: '0 8px 22px rgba(91, 75, 39, 0.06)',
};

export const smartPageSx = {
  minHeight: '100vh',
  bgcolor: SMART_COLORS.page,
  color: SMART_COLORS.text,
};

export const smartTableHeadSx = {
  borderRadius: 0,
  '& .MuiTableRow-head': {
    bgcolor: '#c2ad74',
    borderRadius: 0,
    height: 48,
  },
  '& .MuiTableCell-root': {
    bgcolor: '#c2ad74',
    color: '#fff',
    fontWeight: 900,
    borderTop: 0,
    borderBottom: '2px solid #ad9253',
    borderRadius: '0 !important',
    py: 1.25,
    lineHeight: 1.25,
    letterSpacing: 0,
    whiteSpace: 'nowrap',
  },
};

export const smartTableContainerSx = {
  borderRadius: 0,
  overflowX: 'auto',
};

export const smartTableSx = {
  borderCollapse: 'collapse',
  borderRadius: 0,
};

export const smartActionButtonSx = (color, bg, hoverBg) => ({
  width: 34,
  height: 34,
  color,
  bgcolor: bg,
  border: `1px solid ${bg}`,
  '&:hover': {
    bgcolor: hoverBg || bg,
    borderColor: color,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
});
